import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {  Router } from '@angular/router';
import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-movie',
  templateUrl: './movie.component.html',
  styleUrls: ['./movie.component.css'],
})
export class MovieComponent implements OnInit, AfterViewInit {
  category: string;
  emotions: any = [];
  Genre: any = [];
  movieList: any = [];
  backArrow: any = 'assets/images/cinejoy/arrow-left.png';
  officialLogo = "assets/images/spotlight/Laurel.svg"
  movie: any = [];
  additionalMedia: any = [];
  eventImage: any = [];
  Shorts: any = [];
  starCast: any = [];
  name: any;
  ShortDescriptive1: any = [];
  description: any = [];
  country: any = [];
  AllmovieList: any = [];
  mobilemovieList: any = [];
  rating: number;
  language: string;
  duration: any;
  tags: any = [];
  id: any;
  dates: any;
  subCat: any = [];
  subCategories: any = [];
  filtermovieList: any[];
  public errorApi = false;
  type: any;
  movieDisplayed: any;
  movieId: any;

  constructor(
    public showcaseService: ShowcaseService,
    private router: Router,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {

    if (sessionStorage.getItem('movieNavigation') !== null) {
      this.showcaseService.categoryObs$.next(
        sessionStorage.getItem('movieNavigation')
      );
    }

    this.showcaseService.categoryObs$.subscribe((res) => {
      let item = JSON.parse(res);
      this.category = item.category;
      this.type = item.type;
      this.subCat = item.subCategories;
      this.movieList = []
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      this.errorApi = false;
      if (this.router.url.includes('/archive')) {
        //   this.SpinnerService.show();

        this.showcaseService
          .getShowcaseArchiveListOnCategory(this.category, this.type, this.subCat)
          .subscribe(
            (res) => {
              this.movieList = res.moviesArray;
              if (this.movieList.length <= 0) {
                this.errorApi = true;
              }
              this.movieDisplayed = this.movieList[0];
              this.movieId = this.movieDisplayed.id;
            },

            (err) => {
              this.errorApi = true;
            }
          );
      } else {
        this.showcaseService
          .getMoviesByCategories(this.category, this.type, this.subCat)
          .subscribe(
            (res) => {
              this.movieList = res.moviesArray;
              if (this.movieList.length <= 0) {
                this.errorApi = true;
              }
              this.movieDisplayed = this.movieList[0];
              this.movieId = this.movieDisplayed.id;
            },

            (err) => {
              this.errorApi = true;
            }
          );
      }
    });
  }

  ngAfterViewInit(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    this.showcaseService.scrollObs$.subscribe((res) => {
      if (this.movieId !== res.replace('movies', '')) {
        this.movieId = res.replace('movies', '');
        if (document.getElementById(res)) {
          document.getElementById(res).scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
          this.movieDisplayed = this.movieList.find(
            (v) => v.id == res.replace('movies', '')
          );
        }
      } else {
        this.movieId = res.replace('movies', '');
        this.movieDisplayed = []
        if (document.getElementById(res)) {
          document.getElementById(res).scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
          this.movieDisplayed = this.movieList.find(
            (v) => v.id == res.replace('movies', '')
          );
        }
      }
    });
  }

  openPaymentFlow(Id: number, movieList: any, purchaseStage: string): void {
    const modalRef = this.modalService.open(PurchaseFlowComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.eventId = Id;
    modalRef.componentInstance.premiere = movieList;
    modalRef.componentInstance.purchaseStage = purchaseStage;
  }

  imgDetail(movie) {
    if(movie.id !== this.movieDisplayed.id){
      this.movieDisplayed = movie;
      this.showcaseService.scrollObs$.next(`movies${movie.id}`);
    }
   
  }

  navigateMovieInfo(event) {
    this.router.navigateByUrl(`/cinejoy/showcase/moviepage/${event.id}/${this.getmovieName(event.name)}`)
  }

  shareButton(type) {
    let searchParams = new URLSearchParams();
    let url;
    switch (type) {
      case 'facebook':
        searchParams.set('u', this.movieDisplayed.legacyPurchaseLink);
        searchParams.set('title', this.movieDisplayed.name);
        searchParams.set('text', this.movieDisplayed.description);

        url = 'https://www.facebook.com/sharer/sharer?' + searchParams;
        break;
      case 'twitter':
        searchParams.set('url', environment.apiURL +`create/cinejoy/showcase/moviepage/${this.movieDisplayed.id}/${this.getmovieName(this.movieDisplayed.name)}`);
        searchParams.set('title', this.movieDisplayed.name);
        searchParams.set('text', this.movieDisplayed.description);
        url = 'https://twitter.com/share?' + searchParams;
        break;
    }
    this.share(url)
  }

  share(url) {
    return window.open(
      url,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=300,width=700,height=700'
    );
  }

  getmovieName(moviename) { 
    let name=''
    if(moviename){
      name = moviename.replace(/ /g, '-');
    }
    return name;
  }
}
